import { createFileRoute, Link } from "@tanstack/react-router";
import { DollarSign, Gift, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PageHeading } from "@/components/ui/text";

export const Route = createFileRoute("/_authed/_org/referrals/how-it-works")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="p-6">
      <PageHeading variant="section" wrapperClassName="mb-6">
        How Referrals Work
      </PageHeading>

      <div className="space-y-6">
        <div className="grid gap-4">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-blue-500" />
                Step 1: Invite A Nonprofit
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Send a referral invitation to a nonprofit leader who is not yet
                using Givefront.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <DollarSign className="h-5 w-5 text-green-500" />
                Step 2: They Spend $1,000
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Once your referral joins and spends $1,000 with Givefront Cards,
                you'll be eligible for your reward.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Gift className="h-5 w-5 text-purple-500" />
                Step 3: Get Your Gift Card
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                Check your inbox for an email with further instructions on
                claiming your reward!
              </p>
            </CardContent>
          </Card>
          <Link to="/referrals/send" className="flex-1">
            <Button className="w-full">
              <Mail className="h-4 w-4" />
              Invite via Email
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
